export default defineNuxtRouteMiddleware((to, from) => {
    if (process.client && to && from && to.path !== from.path) {
      const isOnErrorPage = document.getElementById('nuxt-error-page')
      if (isOnErrorPage) {
        window.location.href = to.fullPath
      }
    }
  })